import React from "react";
import FooterComponent from "./../../Generic/Footer/FooterComponent";
import HeaderComponent from "./../../Generic/Header/HeaderComponent";
import SeoMeta from "./../../Generic/SEO/SeoMeta";
import Breadcrumb from "../../UI/Breadcrumb";
import { Button, EmptyState } from "../../UI/Primitives";
import { NAV_CATEGORIES, getCategoryMeta } from "../Catalog/categoryMeta";
import * as endpoint from "./../../../Service/endpoints";

// Shown for catalogue URLs that do not exist (bad links, scrapers, typos).
// Marked noindex so these never enter the search index.
function CategoryNotFound({ citySlug }) {
  const city = endpoint.getCityOption(citySlug) ? citySlug : endpoint.getCurrentCity();

  return (
    <React.Fragment>
      <SeoMeta title="Page not found | Voorent" description="This page doesn't exist. Browse furniture and appliances on rent from Voorent." noindex />
      <HeaderComponent />
      <main id="main-content" className="v-main">
        <div className="v-container">
          <Breadcrumb items={[{ label: "Home", to: endpoint.getRoute("", city) }]} structuredData={false} />
          <EmptyState
            kind="empty"
            title="We couldn't find that page"
            description="The link may be out of date, or the page may have moved. Here's where to go instead."
            actions={
              <>
                <Button to={endpoint.getRoute("furniture", city)} variant="primary">
                  Browse furniture
                </Button>
                <Button to={endpoint.getRoute("appliances", city)} variant="secondary">
                  Browse appliances
                </Button>
              </>
            }
          />
          <nav className="v-landing-cities" aria-label="Browse categories">
            <h2 className="v-landing-cities__title">All categories</h2>
            <ul>
              {NAV_CATEGORIES.map((slug) => (
                <li key={slug}>
                  <a href={endpoint.getRoute(slug, city)} className="v-chip">
                    {getCategoryMeta(slug).short}
                  </a>
                </li>
              ))}
            </ul>
          </nav>
        </div>
      </main>
      <FooterComponent />
    </React.Fragment>
  );
}

export default CategoryNotFound;
